module.exports = __webpack_public_path__ + "img/clipart2350691.8b238850.png";